import { useContext } from 'react';
import { ThemeContext } from '@/contexts';

/** Access the active theme and switch it. Must be used within a `ThemeProvider`. */
export const useTheme = () => {
  const context = useContext(ThemeContext);
  if (!context) {
    throw new Error('useTheme must be used within a ThemeProvider');
  }
  return context;
};
